import GenericStateBlock from './GenericStateBlock';
import { GenericStateBlockProps, GenericStateBlockValueProps } from './types';

export type { GenericStateBlockProps, GenericStateBlockValueProps };
export default GenericStateBlock;
